import React from "react"
import { useTranslation } from "react-i18next"
import InformativeAccordion from "../common/InformativeAccordion"

const UnderstandingIntroversion = () => {
  const { t } = useTranslation()

  return (
    <section className="mx-auto max-w-7xl p-8 space-y-4">
      <h2 className="text-xl md:text-2xl font-semibold">
        {t("introvert-empowerment.understanding-your-introversion.title")}
      </h2>
      <div className="py-5">
        <InformativeAccordion
          items={t(
            "introvert-empowerment.understanding-your-introversion.sectionMessage",
            { returnObjects: true },
          )}
        />
      </div>
    </section>
  )
}

export default UnderstandingIntroversion
